module.exports = __webpack_public_path__ + "img/file-icon_psd.a6f98a5e.svg";